import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import {Button, Icon, Input} from 'elements'

interface Props {
  onChange(value: string): void
}

interface State {
  value: string
}

class SearchInput extends PureComponent<Props, State> {
  state: State = {
    value: ''
  }

  handleChange = (value: string) => {
    this.setState({value})
    this.props.onChange(value)
  }

  render() {
    const {onChange, ...props} = this.props
    const {value} = this.state
    return (
      <Wrapper {...props}>
        <Icon name="search" />
        <StyledInput
          type="text"
          value={value}
          onChange={event => this.handleChange(event.target.value)}
          underline={false}
        />
        <Button onClick={() => this.handleChange('')}>
          <Icon name="del" />
        </Button>
      </Wrapper>
    )
  }
}

export default SearchInput

const Wrapper = cxs('div')({
  display: 'flex'
} as CSSProperties)

const StyledInput = cxs(Input)({
  flex: 1
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SearchInput.tsx